import { Feature } from '../../../constants/feature';
import { endedVoipScreens, loginStates, voipScreens } from '../../../constants/types';
import { useVoipContext } from '../../../hooks/use-voip-context';
import { useWidgetContext } from '../../../hooks/use-widget-context';
import { Page } from '../../../types/constants';
export const useStatusHeader = () => {
    const { displayPanel, hasFeature, platform, isPreAuth } = useWidgetContext();
    const { accessMicroStatus, haveDevices, loginStatus, voipScreen } = useVoipContext();
    const callSupportAvailable = hasFeature(Feature.CallSupport);
    const mobile = platform === 'mobile';
    if (accessMicroStatus === 'DENIED' || haveDevices === 'NOT_MICRO') {
        return 'NOT_ACESS_MICRO_VIEW';
    }
    if (loginStatus === loginStates.PRELOAD || !callSupportAvailable) {
        return 'PRELOAD';
    }
    if (voipScreen === voipScreens.WITHOUT_CALL && mobile && isPreAuth) {
        return 'WITHOUT_CALL_MOBILE_PRE_AUTH';
    }
    if (voipScreen === voipScreens.WITHOUT_CALL && mobile) {
        return 'WITHOUT_CALL_MOBILE';
    }
    if (voipScreen === voipScreens.WITHOUT_CALL && !mobile) {
        return 'WITHOUT_CALL_DESKTOP';
    }
    if (voipScreen === voipScreens.WITH_CALL) {
        return 'WITH_CALL';
    }
    if (endedVoipScreens.includes(voipScreen)) {
        if (displayPanel === Page.OtherContacts) {
            return 'ENDED_VOIP_SCREEN_OTHER_CONTACTS';
        }
        return 'ENDED_VOIP_SCREEN_VOIP';
    }
    return null;
};
